<div class="layout-main">
  <div class="container-fluid">
    <div *ngIf="!loading">
      <div class="pb-2 mb-3 border-bottom">
        <h3><b>Ledger of Local Fiber E-Trees</b></h3>
      </div>
      <div class="row">
        <div class="col-12">
          <p-panel [toggleable]="true">
            <ng-template pTemplate="header">
              <div class="filter-card-header">
                <span class="filter-icon"><i class="fa fa-search"></i></span>
                <span class="filter-card-title">Filter</span>
              </div>
            </ng-template>
            <div class="filter-fields">
              <div class="filter-field">
                <p-floatLabel>
                  <input [(ngModel)]="userChoicesActiveFiltersClfLedger.eTreeId" (ngModelChange)="filterAndReset()"
                         class="form-control" name="etreeId" pInputText type="text"/>
                  <label>E-Tree ID</label>
                </p-floatLabel>
              </div>
              <div class="filter-field">
                <p-floatLabel>
                  <input [(ngModel)]="userChoicesActiveFiltersClfLedger.serviceType" (ngModelChange)="filterAndReset()"
                         class="form-control" name="serviceType" pInputText type="text"/>
                  <label>Service Type</label>
                </p-floatLabel>
              </div>
              <div class="filter-field">
                <p-floatLabel>
                  <p-multiSelect [(ngModel)]="userChoicesActiveFiltersClfLedger.crossConnectId"
                                 (ngModelChange)="filterAndReset()"
                                 [filter]="true" [options]="crossConnectIdOptions" name="crossConnectId"></p-multiSelect>
                  <label>Cross Connect ID</label>
                </p-floatLabel>
              </div>
              <div class="filter-field filter-field--range">
                <p-floatLabel>
                  <p-calendar [(ngModel)]="userChoicesActiveFiltersClfLedger.connectionDateRange"
                              (ngModelChange)="filterAndReset()"
                              [showButtonBar]="true" [showIcon]="true" dataType="string" dateFormat="mm/dd/yy"
                              inputId="connectionDateRange" name="connectionDateRange" selectionMode="range"
                              [style]="{'width':'100%'}"></p-calendar>
                  <label for="connectionDateRange">Connection Date</label>
                </p-floatLabel>
              </div>
              <div class="filter-field filter-field--check">
                <p-checkbox [(ngModel)]="userChoicesActiveFiltersClfLedger.showHistorical" (ngModelChange)="onHistoricalChange()"
                            binary="true" label="Show historical" name="showHistorical"></p-checkbox>
              </div>
              <div class="filter-actions">
                <button (click)="onClickedResetFilter()" class="filter-reset-btn" type="button">
                  <i aria-hidden="true" class="fa fa-refresh"></i>
                  Reset
                </button>
              </div>
            </div>
          </p-panel>
        </div>
      </div>
      <p-table #dataTableClfLedger [columns]="visibleCols"
               [paginator]="true" [rowsPerPageOptions]="[50, 100, 200]" [rows]="50"
               [sortOrder]="-1" [value]="filteredClfLedgerRows"
               sortField="connectionDate">
        <ng-template let-columns pTemplate="header">
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                class="th-{{col.field}}">
              {{ col.header }}
              <p-sortIcon field="{{col.field}}"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template let-columns="columns" let-row pTemplate="body">
          <tr [ngClass]="{'row-removed': isRemoved(row)}">
            <td *ngIf="isMckayUser">{{ row.internalUseOnly }}</td>
            <td>{{ row.serviceType }}</td>
            <td>{{ row.priorScheduleRef ?? 'N/A' }}</td>
            <td>{{ row.eTreeId }}</td>
            <td>{{ row.crossConnectId }}</td>
            <td class="num-cell">{{ displayMonthlyFee(row) }}</td>
            <td class="num-cell">{{ displayBandwidth(row.bandwidthMbps) }}</td>
            <ng-container *ngIf="isIntraColocation(row); else separatePops">
              <td [attr.colspan]="2" class="intra-colocation-cell">
                Intra-colocation data center fiber service at <strong>{{ row.injectionDemarcationPoint }}</strong>
              </td>
            </ng-container>
            <ng-template #separatePops>
              <td>{{ row.injectionDemarcationPoint }}</td>
              <td>{{ row.receptionDemarcationPoint }}</td>
            </ng-template>
            <td>{{ displayDate(row.connectionDate) }}</td>
            <td>{{ displayDate(row.removalDate) }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="visibleCols.length">
              <div class="empty-state">
                <i aria-hidden="true" class="fa fa-search"></i>
                <div class="empty-state-title">No local fiber e-trees found</div>
                <div class="empty-state-subtitle">Try adjusting your search or filters.</div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
